import { i18nextNL } from '@hvcgroep/design-system';

export default {
  'translation': {
    ...i18nextNL.translation,
    'webform_optional': '- optioneel',
    'search_header': 'Uw zoekresultaten',
    'search_button': 'Zoeken',
    'search_result_information': 'Toont resultaten {{from}} - {{to}} van {{total}}',
    'projectmap_search': 'zoeken',
    'projectmap_placeholder': 'Zoek op plaats of postcode',
    'projectmap_township': ' (Gemeente)',
    'projectmap_project_stories': 'Projectverhalen',
    'projectmap_granted_projects': 'Toegekende projecten',
    'projectmap_filters': 'Filteren',
    'projectmap_year_placeholder': 'Jaar',
    'projectmap_theme_placeholder': 'Thema',
    'popup_read_more': 'Lees het hele verhaal',
    'popup_granted_amount': 'Toegekend bedrag:',
    'more_about_this_event': 'Meer over dit evenement',
    'project_year': 'Jaar',
    'project_location': 'Locatie',
    'project_amount': 'Toegekend bedrag',
    'footer_inititive': 'Een initiatief van',
    'footer_supported': 'Gesteund door',
    'footer_registered': 'Geregistreerd bij',
    'footer_contact_information': 'Contactinformatie',
    'share': 'Deel dit op...',
    'apply_vacancy': 'Solliciteer nu',
    'project_see_on_map': 'Bekijk op de kaart',
    'project_share': 'Deel dit project met je vrienden',
    'employees_quickjump': 'Ga snel naar:',
    'awards': {
      'download': {
        'title': 'Download',
        'description': 'Download hieronder uw geselecteerde toekenningen als CSV bestand.',
        'button': 'Download',
      },
    },
    'form': {
      ...i18nextNL.translation.form,
      'field': {
        ...i18nextNL.translation.form.field,
        'file_upload': {
          ...i18nextNL.translation.form.field.file_upload,
          'button': 'Selecteer bestand',
        },
      },
    },
    'view_load_more': 'Laad meer',
    'awards_view_load_more': 'Laad de volgende 10',
    'footer_social': 'Volg ons',
    'webform_required': 'Dit veld is verplicht',
    'webform_file_upload_remove_file': 'Verwijder',
    'webform_file_upload_button': 'Uploaden',
    'webform_file_upload_error': 'Er is iets fout gegaan.',
    'others_also_viewed': 'Anderen bekeken ook',
    'others_also_viewed__series': 'Andere series',
    'taxonomy_term_404': 'Oeps! error 404',
    'not_found': 'Pagina niet gevonden..',
    'not_found_explanation': 'Wellicht is de vacature die je zoekt inmiddels gesloten. Wil je alsnog solliciteren?',
    'not_found_button_open_application': 'Open sollicitatie',
    'not_found_button_vacancy_overview': 'Naar vacatures',
    'maintenance': 'Sorry, onze website is tijdelijk niet beschikbaar in verband met onderhoud.',
    'maintenance_button_hvcgroep': 'naar hvcgroep.nl',
    'socials_list_title': 'Blijf betrokken',
    'socials_list_facebook_link_text': 'Facebook link',
    'socials_list_linkedin_link_text': 'LinkedIn link',
    'socials_list_x_link_text': 'X link',
    'socials_list_instagram_link_text': 'Instagram link',
    'views': {
      'show_more': 'Toon meer',
      'no_results': {
        'vacancies': {
          'overview': 'Pas je filters aan of zoek via het zoekveld. Of schrijf je in voor onze jobalert en ontvang een melding wanneer we wel iets voor jou hebben.',
          'vacancies_for_department': 'Op dit moment zijn er geen vacatures voor dit vakgebied.'
        },
        'internships': {
          'overview': 'Helaas, op dit moment hebben wij geen stageplaatsen, stuur ons een ',
          'link': 'open sollicitatie',
          'url': 'https://solliciteren.werkenbijhvc.nl/aanmaken-sollicitatie-incl-autorisatie-prs/standaard?VcSn=181',
        },
        'events': {
          'all_1': 'Er zijn op dit moment geen evenementen gepland.',
          'all_2': 'Houd onze website in de gaten voor nieuwe evenementen.',
        },
      },
    },
    'requirements': 'Vereisten',
    'vacancy': 'Vacature',
    'whatsapp_link': {
      'short': 'Whatsapp contact',
      'long': 'Meer info via whatsapp',
    },
    'cookies': {
      'heading': 'Welkom bij HVC!',
      'description': 'Wij maken gebruik van cookies om de website optimaal te laten werken op basis van jouw voorkeuren. Daarnaast analyseren en verbeteren wij continu. Lees meer over: <1>cookies</1> en <2>privacybeleid</2>',
      'accept': 'Accepteren',
      'accept_only_necessary': 'Alleen benodigde',
      'accept_selection': 'Selectie accepteren',
      'accept_all': 'Alles accepteren',
      'configure_manually': 'Zelf instellen',
      'cookie_levels': {
        'heading': 'Details',
        'description': 'Cookies zijn kleine tekstbestanden die tijdens jouw bezoek aan een website op jouw computer, tablet of mobiele telefoon worden geplaatst. Een belangrijk doel van cookies is dat ze gebruikt worden om gemak op te leveren. Onze website maakt gebruik van verschillende cookies waarvan wij alleen de noodzakelijke zonder toestemming mogen plaatsen.',
        'necessary': {
          'label': 'Noodzakelijk',
          'description': 'Noodzakelijke cookies helpen de website bruikbaar te maken. Denk aan het gebruiken van de chat en het gebruiken van de navigatie.'
        },
        'preferences': {
          'label': 'Voorkeuren',
          'description': 'Voorkeuren cookies geven inzicht in je interesses, je acties op de website en maken het ook mogelijk een contactformulier te gebruiken.'
        },
        'statistics': {
          'label': 'Statistieken',
          'description': 'Statistieken cookies helpen ons inzicht te krijgen in het gebruik van onze website en maken het onderzoeken naar verbeteringen mogelijk.'
        },
        'marketing': {
          'label': 'Marketing',
          'description': 'Marketing cookies maken het mogelijk om onze campagne resultaten te meten, zo kunnen wij gerichter adverteren en kosten besparen. Wij delen nooit klantgegevens met derden zoals Google en Facebook.'
        }
      }
    },
    'application_sent': {
      'title': 'Bedankt voor je sollicitatie',
      'content': 'We hebben je gegevens goed ontvangen en zullen deze zorgvuldig bekijken. Ons team streeft ernaar om snel te reageren, dus je kunt zo snel als mogelijk een update van ons verwachten. \n\nAls je in de tussentijd vragen hebt of aanvullende informatie wilt delen, aarzel dan niet om contact met ons op te nemen. \n\nWe waarderen je interesse in HVC en kijken ernaar uit om mogelijk met je samen te werken aan duurzame oplossingen voor een schone wereld. \n\nBij HVC doen we het gewoon.',
      'customer_effort_score_label': 'Hoe heb je dit proces ervaren?',
      'customer_effort_score_success': 'Bedankt voor je reactie!',
      'customer_effort_score_error': 'Er ging iets mis bij het versturen van je reactie, probeer het opnieuw.',
    },
    'job_application_form': {
      'title': 'Leuk dat jij bij HVC wil werken',
      'content': 'Laten we beginnen met je basisgegevens.',
      'error': {
        'title': 'Verzenden mislukt',
        'content': 'Helaas, er is iets misgegaan bij het verzenden van je sollicitatie. Probeer het opnieuw.'
      },
      'confirm_close_dialog': {
        'title': 'Let op',
        'content': 'Als je de sollicitatie annuleert, zullen de ingevulde gegevens verloren gaan.',
        'primary_button': 'Sollicitatie annuleren',
        'secondary_button': 'Terug'
      },
      'fields': {
        'agree_to_terms': {
          'label': 'Ik ga akkoord met <1>de privacyverklaring</1>',
          'required': 'Je moet akkoord gaan met de privacyverklaring om door te gaan'
        },
        'first_name': {
          'label': 'Voornaam',
          'placeholder': 'Bijv. Henk',
          'required': 'Je moet je voornaam invullen'
        },
        'last_name': {
          'label': 'Achternaam',
          'placeholder': 'van Coene',
          'required': 'Je moet je achternaam invullen'
        },
        'email': {
          'label': 'Je e-mailadres',
          'placeholder': 'naam@domein.nl',
          'required': 'Je moet je e-mailadres invullen',
          'email': 'Je moet een geldig e-mailadres invullen'
        },
        'phone': {
          'label': 'Je telefoonnummer',
          'placeholder': '06 12341234',
          'required': 'Je moet je telefoonnummer invullen'
        },
        'cv': {
          'label': 'Upload je CV',
          'required': 'Je moet je CV uploaden'
        },
        'cover_letter': {
          'label': 'Upload je motivatiebrief'
        },
        'message': {
          'label': 'Motivatie',
          'placeholder': 'Schrijf je motivatie'
        },
        'has_documents': {
          'label': "Beschik je over de gevraagde diploma's en documenten?",
          'required': "Je moet aangeven of je over de gevraagde diploma's en documenten beschikt",
          'options': {
            'true': 'Ja',
            'false': 'Nee',
          },
        },
      },
      'submit': 'Verzend sollicitatie',
    },
    'customer_effort_score': {
      'labels': {
        'good': 'Goed',
        'bad': 'Slecht',
      },
      'scores': {
        '1': 'Zeer slecht',
        '2': 'Slecht',
        '3': 'Matig',
        '4': 'Goed',
        '5': 'Zeer goed',
      },
    },
    "source": "Bron",
    "unknown": "Onbekend",
    'vacancy_block_contact': {
      'title': 'Ga voor de betere wereldbaan!',
      'body': {
        'main': 'Voor verdere informatie over deze functie kan je contact opnemen met {{ name }} via',
        'tel': 'telefoonnummer {{ tel }}',
        'email': '{{ email }}',
        'tel_only': '$t(vacancy_block_contact.body.main) $t(vacancy_block_contact.body.tel).',
        'email_only': '$t(vacancy_block_contact.body.main) $t(vacancy_block_contact.body.email).',
        'full': '$t(vacancy_block_contact.body.main) $t(vacancy_block_contact.body.tel) of $t(vacancy_block_contact.body.email).',
      },
      'whatsapp_link': 'Direct contact? Stuur een Whatsapp!'
    },
    'searchkit': {
      'vacancies': {
        'search_label': 'Zoek in {{ count }} vacatures',
        'search_placeholder': 'Bijv. chauffeur',
        'load_more_button': 'Toon meer',
        'no_results': 'Pas je filters aan of zoek via het zoekveld. Of schrijf je in voor onze jobalert en ontvang een melding wanneer we wel iets voor jou hebben.',
        'filter_title': 'Filter',
        'filter_reset': 'Wis filters',
        'filter_show_more': 'Toon alles',
        'filter_show_less': 'Toon minder',
        'filter_dialog_open_button': 'Overige filters',
        'filter_dialog_close_button': 'Sluiten',
        'filter_dialog_submit_button_one': 'Toon {{ count }} vacature',
        'filter_dialog_submit_button_other': 'Toon {{ count }} vacatures',
        'facets': {
          'department': 'Vakgebied',
          'address': 'Locatie',
        },
      },
    },
    'contextual_links': {
      'node': {
        'edit': 'Bewerk pagina',
        'delete': 'Verwijder pagina',
      },
      'user': {
        'edit': 'Bewerk gebruiker',
        'delete': 'Verwijder gebruiker',
      },
      'taxonomy_term': {
        'edit': 'Bewerk term',
        'delete': 'Verwijder term',
      },
      'paragraph': {
        'edit': 'Bewerk paragraaf',
        'delete': 'Verwijder paragraaf',
        'clone': 'Dupliceer paragraaf',
      },
      'webform': {
        'edit': 'Bewerk formulier',
        'submissions': 'Bekijk inzendingen',
      },
      'media': {
        'edit': 'Bewerk media',
        'delete': 'Verwijder media',
      },
      'menu': {
        'edit': 'Bewerk menu',
      },
    },
  },
};
